import { useContext, useState } from "react";
import { AuthContext, AppContext } from "@CONTEXTS";
import { Divider, Descriptions, Button, Tooltip } from "antd";
import {
  SafetyCertificateOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import VerifyPhone from "./phone-verify";
import VerifyEmail from "./email-verify";

const Informations = () => {
  const { info } = useContext(AuthContext);
  const { options } = useContext(AppContext);
  const twoFactorEnabled = process.env.REACT_APP_2FA_ENABLED;
  const [verifyType, setVerifyType] = useState(null);
  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(
    info?.isPhoneNumberVerified
  );
  const [phone, setPhone] = useState(info?.phone);
  const [isEmailVerified, setIsEmailVerified] = useState(info?.isEmailVerified);
  return (
    <>
      {verifyType === "PHONE" && (
        <VerifyPhone
          setIsPhoneNumberVerified={setIsPhoneNumberVerified}
          setPhone={setPhone}
          setVerifyType={setVerifyType}
          isPhoneNumberVerified={isPhoneNumberVerified}
        />
      )}
      {verifyType === "EMAIL" && (
        <VerifyEmail
          setIsEmailAddressVerified={setIsEmailVerified}
          email={info.email}
          setVerifyType={setVerifyType}
        />
      )}
      <Descriptions title={"Bilgilerim"} bordered layout="vertical" column={2}>
        <Descriptions.Item
          label={<h3 style={{ width: 500 }}>Kullanıcı Adım</h3>}
          span={1}
        >
          {info?.name ? info?.name : "Bulunmamaktadır."}
        </Descriptions.Item>
        <Descriptions.Item
          label={<h3 style={{ width: 500 }}>Firma Adım</h3>}
          span={1}
        >
          {info?.companyName}
        </Descriptions.Item>
        {twoFactorEnabled === "true" && info?.twoFactorEnabled && (
          <>
            <Descriptions.Item
              label={<h3 style={{ width: 500 }}>E-posta Adresim</h3>}
              span={1}
            >
              {info?.email}
              {isEmailVerified ? (
                <Tooltip title="E-posta doğrulandı">
                  <CheckCircleFilled
                    style={{
                      color: "#52c41a",
                      marginLeft: 4,
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title="E-posta adresi doğrulama">
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => setVerifyType("EMAIL")}
                    style={{
                      marginLeft: 6,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <SafetyCertificateOutlined style={{ marginBottom: 8 }} />
                      E-posta adresi doğrulama
                    </div>
                  </Button>
                </Tooltip>
              )}
            </Descriptions.Item>
            <Descriptions.Item
              label={<h3 style={{ width: 500 }}>Telefon Numaram</h3>}
              span={1}
            >
              {phone}
              {isPhoneNumberVerified ? (
                <>
                  <Tooltip title="Cep telefonu doğrulandı">
                    <CheckCircleFilled
                      style={{
                        color: "#52c41a",
                        marginLeft: 4,
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                  <Tooltip title="Cep telefonu doğrulama">
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => setVerifyType("PHONE")}
                      style={{ marginLeft: 6 }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <SafetyCertificateOutlined
                          style={{ marginBottom: 8 }}
                        />
                        Numarayı güncelle
                      </div>
                    </Button>
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Cep telefonu doğrulama">
                  <Button
                    type="primary"
                    size="small"
                    // shape="circle"
                    onClick={() => setVerifyType("PHONE")}
                    style={{ marginLeft: 6 }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <SafetyCertificateOutlined style={{ marginBottom: 8 }} />
                      Cep telefonu doğrulama
                    </div>
                  </Button>
                </Tooltip>
              )}
            </Descriptions.Item>
          </>
        )}
        {info?.TCKN && (
          <Descriptions.Item
            label={<h3 style={{ width: 500 }}>TC Kimlik Numarası</h3>}
            span={info?.VKN ? 1 : 2}
          >
            {info?.TCKN}
          </Descriptions.Item>
        )}
        {info?.VKN && (
          <Descriptions.Item
            label={<h3 style={{ width: 500 }}>VKN</h3>}
            span={info?.TCKN ? 1 : 2}
          >
            {info?.VKN}
          </Descriptions.Item>
        )}
        <Descriptions.Item
          label={<h3 style={{ width: 500 }}>Tanımlı Depolarım</h3>}
          span={3}
        >
          {options?.WAREHOUSES
            ? options?.WAREHOUSES?.map((value, i) => (
                <div key={value?.tr + i}>
                  <div style={{ display: "flex" }}>
                    <h4> {value?.name} </h4>
                    <p style={{ margin: "0 4px" }}>:</p>
                    <p>{value?.tr}</p>
                  </div>
                  {i + 1 < options?.WAREHOUSES?.length && (
                    <Divider type="horizontal" />
                  )}
                </div>
              ))
            : "Bulunmamaktadır."}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default Informations;
